/* eslint-disable import/no-unresolved */
import React from 'react';

import teamextensionSVG from 'assets/resources/icon/teamextension_icon.svg';
import imagesPillarPages from '../../../imagesPillarPages';
import imagesLandingPages from '../../../imagesLandingPages';

import SingleBox from './AboutSingleBox';

const InfoBox = () => {
  return (
    <div className="info-box">
      <div className="row">
        <SingleBox
          image={imagesLandingPages.pythonSVG}
          lg
          heading="Python development"
          details="Use the backend’s most powerful language to build any software feature."
          link="/software-services/python-development/"
        />
        <SingleBox
          image={imagesPillarPages.logoJS}
          heading="JavaScript development"
          lg
          details="Craft dynamic and responsive digital experiences harnessing JavaScript’s flexibility."
          link="/software-services/javascript-development/"
        />
        <SingleBox
          image={imagesPillarPages.chainSVG}
          lg
          heading="Blockchain development"
          details="Build decentralized applications and custom blockchains and disrupt industries."
          link="/software-services/blockchain-development/"
        />
        <SingleBox
          image={imagesPillarPages.graphSVG}
          lg
          heading="Cryptocurrency and trading platforms"
          details="Combine blockchain, smart contracts, digital wallets, and the highest security standards."
          link="/software-services/cryptocurrency-trading-platforms/"
        />

        <SingleBox
          image={imagesPillarPages.rocketSVG}
          lg
          heading="Minimum Viable Product development"
          details="Turn your idea into an MVP and get market feedback quickly to grow your startup or SME."
          link="/software-services/mvp-minimum-viable-product-development/"
        />

        <SingleBox
          image={teamextensionSVG}
          lg
          heading="Team extension"
          details="Use our team’s support to grow your venture on an ongoing basis."
          link="/software-services/team-extension/"
        />
      </div>
    </div>
  );
};

export default InfoBox;
